import SysAdminInstancesList from './entities/sys-admin-instances-list';
import SysAdminInstanceDetails from './entities/sys-admin-instance-details';
import SysAdminInstanceSubscriptionsList from './entities/sys-admin-instance-subscriptions-list';
import SysAdminInstanceSubscriptionsDetails from './entities/sys-admin-instance-subscriptions-details';
import SysAdminInstanceSubscriptionInvoicesList from './entities/sys-admin-instance-subscription-invoices-list';
import SysAdminInstanceSubscriptionInvoiceDetails from './entities/sys-admin-instance-subscription-invoice-details';

export default {
  modules: {
    SysAdminInstancesList,
    SysAdminInstanceDetails,
    SysAdminInstanceSubscriptionsList,
    SysAdminInstanceSubscriptionsDetails,
    SysAdminInstanceSubscriptionInvoicesList,
    SysAdminInstanceSubscriptionInvoiceDetails,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/system-administration/index.js